import React, { useState, useEffect } from "react";
import { useSwipeable } from "react-swipeable";
import { useNavigate } from "react-router-dom";
import slide1 from "../assets/welcome1.jpeg";
import slide2 from "../assets/welcome2..jpeg";
import slide3 from "../assets/welcome3.jpeg";
import slide4 from "../assets/welcome4.jpeg";
import slide5 from "../assets/welcome5.jpeg";
import slide6 from "../assets/welcome6.jpeg";

import slide8 from "../assets/welcome8.jpeg";

const slides = [
  {
    image: slide1,
    header: "Access to 24/7 Care is Here",
    subtitle: "Expert support whenever and wherever you need it, anytime.",
  },
  {
    image: slide2,
    header: "Electronic Health Record, Simplified",
    subtitle: "Browse and explore your health history from medical professionals.",
  },
  {
    image: slide3,
    header: "Most Accurate AI Symptom Checker",
    subtitle: "Immediate guidance instead of waiting or guessing.",
  },
    {
    image: slide4,
    header: "AI Health & Medical Assistant",
    subtitle: "AI-driven support for smarter health decisions, powered by most capable health LLMs.",
  },
  {
    image: slide5,
    header: "E-Pharmacies & Lab Diagnostics",
    subtitle: "Compare prices instantly and save on your medications, with no downside",
  },
  {
    image: slide6,
    header: "A Health Metrics That Understands You",
    subtitle: "Insights designed around your unique needs and professional needs",
  },
   
    {
    image: slide8,
    header: "Personalized Health That You Can Control",
    subtitle: "Take charge of your journey effortlessly.",
  },
  
];
export default function WelcomeScreen({ onFinish }) {
  const [current, setCurrent] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev < slides.length - 1 ? prev + 1 : prev));
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const handlers = useSwipeable({
    onSwipedLeft: () => setCurrent((prev) => Math.min(prev + 1, slides.length - 1)),
    onSwipedRight: () => setCurrent((prev) => Math.max(prev - 1, 0)),
    trackMouse: true,
  });

  return (
    <div {...handlers} className="position-relative vh-100 overflow-hidden">

      {/* Background Images */}
      {slides.map((slide, index) => (
        <img
          key={index}
          src={slide.image}
          alt=""
          className="position-absolute top-0 start-0 w-100 h-100"
          style={{
            objectFit: "cover",
            objectPosition: "center",
            opacity: current === index ? 1 : 0,
            transition: "opacity 0.6s ease-in-out",
            zIndex: 1,
          }}
        />
      ))}

      {/* Gradient overlay (VERY IMPORTANT) */}
      <div
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{
         
          zIndex: 2,
        }}
      />

      {/* Text Content */}
      <div
        className="position-absolute text-center text-white px-4"
        style={{
          bottom: "120px",
          left: 0,
          color : "black",
          right: 0,
          zIndex: 3,
        }}
      >
        <h2 style={{ fontWeight: 700, color : "black" }}>{slides[current].header}</h2>
        <p style={{ opacity: 0.9,  color : "black"  }}>{slides[current].subtitle}</p>
      </div>

      {/* Controls */}
      <div
        className="position-absolute d-flex justify-content-between align-items-center px-4"
        style={{
          bottom: "40px",
          width: "100%",
          zIndex: 3,
        }}
      >
        {/* Left */}
        <button
          className="rounded-circle arrow-btn"
          onClick={() => setCurrent((p) => Math.max(p - 1, 0))}
          disabled={current === 0}
        >
          &#8592;
        </button>

        {/* Indicators */}
        <div className="d-flex gap-2">
          {slides.map((_, index) => (
            <span
              key={index}
              onClick={() => setCurrent(index)}
              style={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                background: current === index ? "#000000" : "rgba(60, 60, 60, 0.4)",
              }}
            />
          ))}
        </div>

        {/* Right */}
        {current < slides.length - 1 ? (
          <button
            className="rounded-circle arrow-btn"
            onClick={() => setCurrent((p) => Math.min(p + 1, slides.length - 1))}
          >
            &#8594;
          </button>
        ) : (
          <button
            className="rounded-circle"
            style={{
              width: 50,
              height: 50,
              background: "#7C4DFF",
              color: "#fff",
              border: "none",
            }}
            onClick={() => {
              localStorage.setItem("HAS_SEEN_WELCOME", "true");
              navigate("/signin");
            }}
          >
            &#10003;
          </button>
        )}
      </div>
    </div>
  );
}
